import React, {FC, forwardRef, useCallback} from 'react';

import {cn} from '@bem-react/classname';
import {Suggest} from '@yandex-data-ui/common';
import {SuggestItem} from 'common/models/survey';

import {SuggestTextProps} from './SuggestText.types';

import './SuggestText.scss';

const cnSuggestText = cn('SuggestText');

const iframe = window.YC?.iframe;

const SuggestText: FC<SuggestTextProps> = forwardRef<HTMLDivElement, SuggestTextProps>(
    function SuggestText({onUpdate, error, ...props}, ref) {
        const onSelect = useCallback(
            (item: SuggestItem) => {
                onUpdate(item.text ?? '');
            },
            [onUpdate],
        );

        const renderItem = useCallback(
            (item: SuggestItem) => <div className={cnSuggestText('Item')}>{item.text}</div>,
            [],
        );

        return (
            <div className={cnSuggestText('Control')} ref={ref}>
                <Suggest
                    renderItem={renderItem}
                    debounce={500}
                    size="l"
                    hasClear
                    showItemsOnNoText
                    getItemsOnMount
                    {...props}
                    onUpdate={onUpdate}
                    onItemClick={onSelect}
                    className={cnSuggestText('Suggest')}
                    inputClassName={cnSuggestText('Input')}
                    error={Boolean(error)}
                    popupClassName={cnSuggestText('Popup', {iframe})}
                />
            </div>
        );
    },
);
export default SuggestText;
